import React from "react";
import { useDispatch } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import useMediaQuery from "@mui/material/useMediaQuery";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import WebAssetIcon from "@mui/icons-material/WebAsset";
import { Gauge, gaugeClasses } from "@mui/x-charts/Gauge";
import { widgetActions } from "../../../redux/widget/widgetSlice";
import { NAVIGATION_GRID_ID, BATTERY_WIDGET_ID } from "../../../config/widget";

export const MIN_VOLTAGE = 3.6;
export const MAX_VOLTAGE = 4.2;

const VoltageCard = ({ voltage, source, label, name }: { voltage: string, source: string, label: string, name: string }) => {

    const dispatch = useDispatch();
    const medium = useMediaQuery((theme: any) => theme.breakpoints.down('xl'));

    const value = Number(voltage);

    const addWidget = () => {
        dispatch(widgetActions.add_widget({ gridId: NAVIGATION_GRID_ID, id: uuidv4(), kind: BATTERY_WIDGET_ID, params: { source, label, name }, medium }));
    };

    return (
        <Card sx={{minWidth: 300, maxWidth: "90%", m: 2, height: 200, minHeight: 100, maxHeight: "90%", overflow: "scroll"}}>
            <CardContent sx={{height: "90%", position: "relative"}}>
                <Stack direction="row" justifyContent="space-between">
                    <Typography variant="h6">Battery</Typography>
                    <Tooltip title="Add Widget" placement="top">
                        <IconButton onClick={addWidget} sx={{marginRight: -1, marginTop: -1}}>
                            <WebAssetIcon fontSize="small"/>
                        </IconButton>
                    </Tooltip>
                </Stack>
                <Gauge
                    value={value < MIN_VOLTAGE ? MIN_VOLTAGE : value > MAX_VOLTAGE ? MAX_VOLTAGE : value}
                    valueMin={MIN_VOLTAGE}
                    valueMax={MAX_VOLTAGE}
                    startAngle={-110}
                    endAngle={110}
                    text={() => `${Number(value.toFixed(2))} V`}
                    sx={{
                        [`& .${gaugeClasses.valueArc}`]: {
                            fill: value < 3.7 ? "red" : value < 3.8 ? "orange" : "limegreen"
                        },
                        fontSize: 20
                    }}
                />
            </CardContent>
        </Card>
    );
};

export default VoltageCard;